import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Leaf, Building, Users } from 'lucide-react';
import SEO from '../components/SEO';
import { FadeIn, PageHero } from '../components/PageComponents';
import { duurzameDetacheringData } from '../data/geoData';

const DuurzameDetacheringPage = () => (
  <main className="pt-28 min-h-screen">
    <SEO title="Duurzame Detachering - Staffing Force" description="Staffing Force is pionier in duurzame detachering in Nederland. B Corp gecertificeerd, CO2-gecompenseerd en gericht op gelijke kansen." keywords="duurzame detachering, B Corp, duurzaam ondernemen, staffing force" />
    <PageHero label="Duurzaam ondernemen" title={duurzameDetacheringData.title} description={duurzameDetacheringData.intro} image="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920&q=85&auto=format&fit=crop" />
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-16">
        <FadeIn>
          <div className="bg-gray-50 rounded-xl p-8 border border-gray-100 h-full">
            <Building size={28} className="text-[#00897B] mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Voor Opdrachtgevers</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">{duurzameDetacheringData.opdrachtgever.intro}</p>
            <ul className="space-y-3 mb-6">{duurzameDetacheringData.opdrachtgever.benefits.map((b,i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-600"><CheckCircle size={16} className="text-[#00897B] mt-0.5 flex-shrink-0" />{b}</li>)}</ul>
            <Link to="/duurzame-detachering/opdrachtgever" className="text-[#00897B] font-semibold text-sm flex items-center gap-1 hover:gap-2 transition-all">Meer informatie <ArrowRight size={14} /></Link>
          </div>
        </FadeIn>
        <FadeIn delay={0.15}>
          <div className="bg-gray-50 rounded-xl p-8 border border-gray-100 h-full">
            <Users size={28} className="text-[#00897B] mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Voor Kandidaten</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">{duurzameDetacheringData.kandidaten.intro}</p>
            <ul className="space-y-3 mb-6">{duurzameDetacheringData.kandidaten.benefits.map((b,i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-600"><CheckCircle size={16} className="text-[#00897B] mt-0.5 flex-shrink-0" />{b}</li>)}</ul>
            <Link to="/duurzame-detachering/kandidaten" className="text-[#00897B] font-semibold text-sm flex items-center gap-1 hover:gap-2 transition-all">Meer informatie <ArrowRight size={14} /></Link>
          </div>
        </FadeIn>
      </div>
    </section>
    <section className="py-20 bg-[#00897B]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <FadeIn>
          <Leaf size={40} className="text-white mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-white mb-4">Duurzaamheid zit in ons DNA</h2>
          <p className="text-white/80 mb-8">Als B Corp gecertificeerd bureau staan wij voor eerlijk, transparant en duurzaam ondernemen.</p>
          <Link to="/certificering" className="bg-white text-[#00897B] px-8 py-3 rounded font-semibold text-sm transition-all hover:-translate-y-0.5">Onze certificeringen</Link>
        </FadeIn>
      </div>
    </section>
  </main>
);

export default DuurzameDetacheringPage;
